import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';

import { AppRoutingModule } from '../routing/app-routing.module';
import { BusinessDetailComponent } from './business-detail/business-detail.component';
import { ContactComponent } from './contact/contact.component';
import { AppMaterialModule } from '../app-material.module';
import { BusinessService } from './business.service';
import { SharedModule } from '../shared/shared.module';
import { BusinessOverviewComponent } from './business-overview/business-overview.component';
import { BusinessFuelComponent } from './business-fuel/business-fuel.component';
import { BusinessMaintenanceComponent } from './business-maintenance/business-maintenance.component';
import { TrainingComponent } from './training/training.component';
import { RentalsComponent } from './rentals/rentals.component';
import { BusinessSalesComponent } from './business-sales/business-sales.component';
import { AssociatedAirportsComponent } from './associated-airports/associated-airports.component';
import { BusinessAmenitiesComponent } from './business-amenities/business-amenities.component';
import { FlyingClubComponent } from './flying-club/flying-club.component';
import { EducationalInfoComponent } from './educational-info/educational-info.component';
import { BusinessPageComponent } from './business-page/business-page.component';
import { FeesSectionComponent } from './fees-section/fees-section.component';
import { EditOverviewComponent } from './edit-overview/edit-overview.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { CommunicationComponent } from './communication/communication.component';
import { HoursComponent } from './hours/hours.component';

import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule, MatExpansionModule, MatSortModule, MatTableModule, MatInputModule } from '@angular/material';
import { MatSelectModule, MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { FlyingclubPageComponent } from './flyingclub-page/flyingclub-page.component';
import { FlyingclubDetailComponent } from './flyingclub-detail/flyingclub-detail.component';
import { EditContactComponent } from './edit-contact/edit-contact.component';
import { DeleteContactComponent } from './delete-contact/delete-contact.component';
import { ContactService } from './services/contact.service';
import { FlightDeckButtonComponent } from './flight-deck-button/flight-deck-button.component';
import { AdminBusinessComponent } from './admin-business/admin-business.component';
import { EditAddAirportComponent } from './edit-add-airport/edit-add-airport.component';
import { ConfirmRemoveAirportComponent } from './confirm-remove-airport/confirm-remove-airport.component';
import { EditClubDetailsComponent } from './edit-club-details/edit-club-details.component';
import { BusinessAdminNotesService } from './services/businessAdminNotes.service';
import { AutoAdjustTextAreaDirective } from './directives/auto-adjust-text-area.directive';
import { EditCommunicationComponent } from './edit-communication/edit-communication.component';
import { CreditCardsComponent } from './credit-cards/credit-cards.component';
import { EditFuelComponent } from './edit-fuel/edit-fuel.component';
import { DeleteFuelComponent } from './delete-fuel/delete-fuel.component';
import { FuelService } from './services/fuel.service';
import { EditBusinessHoursComponent } from './edit-business-hours/edit-business-hours.component';
import { BusinessHoursTableComponent } from './business-hours-table/business-hours-table.component';
import { BusinessHoursValidatorService } from './business-hours-table/business-hours-validator.service';
import { BusinessHoursService } from './services/business-hours.service';
import { BusinessFeesService } from './services/business-fees.service';
import { FuelProvidersComponent } from './fuel-providers/fuel-providers.component';
import { BusinessWebcamsComponent } from './business-webcams/business-webcams.component';
import { EditWebcamComponent } from './edit-webcam/edit-webcam.component';
import { DeleteWebcamComponent } from './delete-webcam/delete-webcam.component';
import { EditFeeComponent } from './edit-fee/edit-fee.component';
import { DeleteFeeComponent } from './delete-fee/delete-fee.component';
import { BlueBoxDialogComponent } from './blue-box-dialog/blue-box-dialog.component';
import { BusinessDescriptionComponent } from './business-description/business-description.component';
import { EditDescComponent } from './edit-desc/edit-desc.component';
import { AwardsAndRecognitionsComponent } from './awards-and-recognitions/awards-and-recognitions.component';
import { SelectMagazineDialogComponent } from './select-magazine-dialog/select-magazine-dialog.component';
import { HelpDialogComponent } from './help-dialog/help-dialog.component';
import { NotApprovedHeaderComponent } from './not-approved-header/not-approved-header.component';
import { AnalyticsService } from '../airport/service/google-analytics-4.service';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    AgmCoreModule,
    AppMaterialModule,
    MatGridListModule,
    MatRadioModule,
    MatExpansionModule,
    MatButtonModule,
    MatSortModule,
    MatTableModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  exports: [
    BusinessDetailComponent
  ],
  declarations: [
    BusinessDetailComponent,
    BusinessOverviewComponent,
    BusinessFuelComponent,
    ContactComponent,
    BusinessMaintenanceComponent,
    TrainingComponent,
    RentalsComponent,
    BusinessSalesComponent,
    AssociatedAirportsComponent,
    BusinessAmenitiesComponent,
    FlyingClubComponent,
    EducationalInfoComponent,
    BusinessPageComponent,
    FeesSectionComponent,
    EditOverviewComponent,
    CommunicationComponent,
    HoursComponent,
    FlyingclubPageComponent,
    FlyingclubDetailComponent,
    EditContactComponent,
    DeleteContactComponent,
    FlightDeckButtonComponent,
    AdminBusinessComponent,
    EditAddAirportComponent,
    ConfirmRemoveAirportComponent,
    EditClubDetailsComponent,
    AutoAdjustTextAreaDirective,
    EditCommunicationComponent,
    CreditCardsComponent,
    EditFuelComponent,
    DeleteFuelComponent,
    EditBusinessHoursComponent,
    BusinessHoursTableComponent,
    FuelProvidersComponent,
    BusinessWebcamsComponent,
    EditWebcamComponent,
    DeleteWebcamComponent,
    EditFeeComponent,
    DeleteFeeComponent,
    BlueBoxDialogComponent,
    BusinessDescriptionComponent,
    EditDescComponent,
    AwardsAndRecognitionsComponent,
    SelectMagazineDialogComponent,
    HelpDialogComponent,
    NotApprovedHeaderComponent
  ],
  providers: [
    BusinessService,
    ContactService,
    BusinessAdminNotesService,
    FuelService,
    BusinessHoursValidatorService,
    BusinessHoursService,
    BusinessFeesService,
    AnalyticsService
  ],
  entryComponents: [
    EditOverviewComponent,
    EditContactComponent,
    DeleteContactComponent,
    AdminBusinessComponent,
    EditAddAirportComponent,
    ConfirmRemoveAirportComponent,
    EditClubDetailsComponent,
    EditCommunicationComponent,
    EditFuelComponent,
    DeleteFuelComponent,
    EditBusinessHoursComponent,
    EditWebcamComponent,
    DeleteWebcamComponent,
    EditFeeComponent,
    DeleteFeeComponent,
    BlueBoxDialogComponent,
    EditDescComponent,
    SelectMagazineDialogComponent,
    HelpDialogComponent
  ]
})
export class BusinessModule {
}
